import ServicesApi from './ServicesApi';

export default class ConfigurationApi {
  static servicePrefix = 'configurationservice/';

  static async getTemplates() {
    const headers = await ServicesApi.getHeaders();

    const templatesResponse = await fetch(
      ConfigurationApi.servicePrefix + 'templates', {
      method: 'GET',
      headers: headers
    });

    return await templatesResponse.json();
  }

  static async getRoles() {
    const headers = await ServicesApi.getHeaders();

    const rolesResponse = await fetch(
      ConfigurationApi.servicePrefix + 'roles', {
      method: 'GET',
      headers: headers
    });

    try {
      return await rolesResponse.json();
    }
    catch (err) {
      return [];
    }
  }

  static async getMetadataRules() {
    const headers = await ServicesApi.getHeaders();

    const rulesResponse = await fetch(
      ConfigurationApi.servicePrefix + 'metadatarules', {
      method: 'GET',
      headers: headers
    });

    return await rulesResponse.json();
  }

  static async getImageMimeTypes() {
    const headers = await ServicesApi.getHeaders();

    const rulesResponse = await fetch(
      ConfigurationApi.servicePrefix + 'imagemimetypes', {
      method: 'GET',
      headers: headers
    });

    return await rulesResponse.json();
  }

  static async getCounterparties() {
    const headers = await ServicesApi.getHeaders();

    const counterpartiesResponse = await fetch(
      ConfigurationApi.servicePrefix + 'counterparties', {
      method: 'GET',
      headers: headers
    });

    return await counterpartiesResponse.json();
  }

  static async postCounterparty(counterpartyDto) {
    const headers = await ServicesApi.getHeaders();

    return await fetch(
      ConfigurationApi.servicePrefix + 'counterparty', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(counterpartyDto)
    });
  }

  static async putCounterparty(counterpartyDto) {
    const headers = await ServicesApi.getHeaders();

    return await fetch(
      ConfigurationApi.servicePrefix + 'counterparty', {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(counterpartyDto)
    });
  }

  static async deleteCounterparty(counterpartyGuid) {
    const headers = await ServicesApi.getHeaders();

    return await fetch(
      ConfigurationApi.servicePrefix + 'counterparty?counterpartyGuid=' + counterpartyGuid, {
      method: 'DELETE',
      headers: headers
    });
  }

  static async getCounterpartyLogo(counterpartyGuid) {
    const headers = await ServicesApi.getHeaders();

    const counterpartyLogoResponse = await fetch(
      ConfigurationApi.servicePrefix + 'counterpartyLogo?counterpartyGuid=' + counterpartyGuid, {
      method: 'GET',
      headers: headers
    });

    return await counterpartyLogoResponse.json();
  }

  static async postCounterpartyLogo(counterpartyLogoDto) {
    const headers = await ServicesApi.getHeaders();

    return await fetch(
      ConfigurationApi.servicePrefix + 'counterpartyLogo', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(counterpartyLogoDto)
    });
  }

  static async putCounterpartyLogo(counterpartyLogoDto) {
    const headers = await ServicesApi.getHeaders();

    return await fetch(
      ConfigurationApi.servicePrefix + 'counterpartyLogo', {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(counterpartyLogoDto)
    });
  }

  static async deleteCounterpartyLogo(counterpartyGuid) {
    const headers = await ServicesApi.getHeaders();

    return await fetch(
      ConfigurationApi.servicePrefix + 'counterpartyLogo?counterpartyGuid=' + counterpartyGuid, {
      method: 'DELETE',
      headers: headers
    });
  }

  static async getContracts(counterpartyGuid) {
    const headers = await ServicesApi.getHeaders();

    const contractsResponse = await fetch(
      ConfigurationApi.servicePrefix + 'contracts?counterpartyGuid=' + counterpartyGuid, {
      method: 'GET',
      headers: headers
    });

    return await contractsResponse.json();
  }

  static async postContract(contractDto) {
    const headers = await ServicesApi.getHeaders();

    return await fetch(
      ConfigurationApi.servicePrefix + 'contract', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(contractDto)
    });
  }

  static async putContract(contractDto) {
    const headers = await ServicesApi.getHeaders();

    return await fetch(
      ConfigurationApi.servicePrefix + 'contract', {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(contractDto)
    });
  }

  static async deleteContract(contractGuid) {
    const headers = await ServicesApi.getHeaders();

    return await fetch(
      ConfigurationApi.servicePrefix + 'contract?contractGuid=' + contractGuid, {
      method: 'DELETE',
      headers: headers
    });
  }

  static async retrieveSettings() {
    const headers = await ServicesApi.getHeaders();

    const settingsResponse = await fetch(
      ConfigurationApi.servicePrefix + 'settings', {
      method: 'GET',
      headers: headers
    });

    return await settingsResponse.json();
  }

  static async retrieveSettingValues() {
    const headers = await ServicesApi.getHeaders();

    const settingValuesResponse = await fetch(
      ConfigurationApi.servicePrefix + 'settingvalues', {
      method: 'GET',
      headers: headers
    });

    return await settingValuesResponse.json();
  }

  static async updateSettingValues(settingValueDtos) {
    const headers = await ServicesApi.getHeaders();

    return await fetch(
      ConfigurationApi.servicePrefix + 'settingvalues', {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(settingValueDtos)
    });
  }
}